var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.555664,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FF947A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8057 18.03C18.8057 18.57 18.9557 18.65 19.2957 18.77L19.8057 18.95V17.25H19.5057C19.1257 17.25 18.8057 17.6 18.8057 18.03Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3057 22.75H21.6057C21.9957 22.75 22.3057 22.4 22.3057 21.97C22.3057 21.43 22.1557 21.35 21.8157 21.23L21.3057 21.05V22.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1357 13.48L26.0857 15.53C25.9357 15.68 25.7457 15.75 25.5557 15.75C25.3657 15.75 25.1757 15.68 25.0257 15.53C24.7357 15.24 24.7357 14.76 25.0257 14.47L27.0757 12.42C25.3157 10.92 23.0457 10 20.5557 10C15.0357 10 10.5557 14.48 10.5557 20C10.5557 25.52 15.0357 30 20.5557 30C26.0757 30 30.5557 25.52 30.5557 20C30.5557 17.51 29.6357 15.24 28.1357 13.48ZM22.3057 19.82C22.9457 20.05 23.8057 20.51 23.8057 21.98C23.8057 23.23 22.8157 24.26 21.6057 24.26H21.3057V24.51C21.3057 24.92 20.9657 25.26 20.5557 25.26C20.1457 25.26 19.8057 24.92 19.8057 24.51V24.26H19.7257C18.3957 24.26 17.3057 23.14 17.3057 21.76C17.3057 21.34 17.6457 21 18.0557 21C18.4657 21 18.8057 21.34 18.8057 21.75C18.8057 22.3 19.2157 22.75 19.7257 22.75H19.8057V20.53L18.8057 20.18C18.1657 19.95 17.3057 19.49 17.3057 18.02C17.3057 16.77 18.2957 15.74 19.5057 15.74H19.8057V15.5C19.8057 15.09 20.1457 14.75 20.5557 14.75C20.9657 14.75 21.3057 15.09 21.3057 15.5V15.75H21.3857C22.7157 15.75 23.8057 16.87 23.8057 18.25C23.8057 18.66 23.4657 19 23.0557 19C22.6457 19 22.3057 18.66 22.3057 18.25C22.3057 17.7 21.8957 17.25 21.3857 17.25H21.3057V19.47L22.3057 19.82Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2457 9.71C31.1657 9.53 31.0257 9.38 30.8357 9.3C30.7457 9.27 30.6557 9.25 30.5557 9.25H26.5557C26.1457 9.25 25.8057 9.59 25.8057 10C25.8057 10.41 26.1457 10.75 26.5557 10.75H28.7457L27.0757 12.42C27.4557 12.75 27.8057 13.1 28.1357 13.48L29.8057 11.81V14C29.8057 14.41 30.1457 14.75 30.5557 14.75C30.9657 14.75 31.3057 14.41 31.3057 14V10C31.3057 9.9 31.2857 9.81 31.2457 9.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUse);
export default __webpack_public_path__ + "static/media/icon_use.8bc4a0cf9f6af5ab00a5e207a2195d15.svg";
export { ForwardRef as ReactComponent };